import DOMPurify from 'dompurify';
import { useEffect, useRef, useState, ClipboardEvent } from 'react';
import { client } from '../../../../utils/axios-client';
import { Token, TokenType } from '../types/content-editor-types';

const useEditor = (tokenType: TokenType) => {
    const ref = useRef<HTMLDivElement>(null);
    const [tokens, setTokens] = useState<Token[]>([]);

    useEffect(() => {
        const loadTokens = async () => {
            const response = await client.get('/api/options/editortokens', { params: { tokenType } });

            setTokens(response.data);
        };

        if (tokenType !== TokenType.None) {
            loadTokens();
        } else {
            setTokens([]);
        }
    }, [tokenType]);

    const handleCommand = (commandId: string, argument: null | string = '') => {
        switch (commandId) {
            case 'createLink':
                argument = prompt('What is the address of the link?');
                break;
            case 'insertImage':
                argument = prompt(
                    'Enter the link to the image',
                    'https://static.wixstatic.com/media/c12bd0_e3230d3dfe964877b012f4ff3a4362f6~mv2.png/v1/fill/w_158,h_71,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/DWCC-2020-Logo_edited.png',
                );
                break;
        }

        if (argument === null) argument = '';

        document.execCommand('enableObjectResizing', false, 'true');
        document.execCommand(commandId, false, argument);
    };

    const onPaste = async (event: ClipboardEvent<HTMLDivElement>) => {
        event.preventDefault();

        const clipboardData = event.clipboardData;
        if (!clipboardData) return;

        // Check if clipboard has an image
        const items = clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.type.startsWith('image')) {
                const blob = item.getAsFile();
                if (blob) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const base64Data = e.target?.result as string;
                        const imgElement = `<img src="${base64Data}" alt="pasted image" />`;
                        document.execCommand('insertHTML', false, imgElement);
                    };
                    reader.readAsDataURL(blob);
                }
            } else if (item.type === 'text/html') {
                const htmlContent = clipboardData.getData('text/html');
                document.execCommand('insertHTML', false, htmlContent);
            } else {
                const text = clipboardData.getData('text/plain');
                document.execCommand('insertHTML', false, text);
            }
        }
    };

    return { ref, tokens, handleCommand, onPaste };
};

export default useEditor;
